module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/14-8c7f26328bb57afb52305db89be7cf0f.jpg";